import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faAngleDoubleUp,
  faChevronRight,
  faExternalLinkAlt,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'

export const AngleDoubleUp = () => <FontAwesomeIcon icon={faAngleDoubleUp} />
export const ChevronRight = () => <FontAwesomeIcon icon={faChevronRight} />
export const ExternalLinkAlt = () => <FontAwesomeIcon icon={faExternalLinkAlt} />
export const Times = () => <FontAwesomeIcon icon={faTimes} />
